import React from 'react';
import { BarChart2, Users, Award, CalendarDays} from 'lucide-react';

const StatsCard = ({ icon: Icon, number, label, suffix = '' }) => (
  <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col items-center justify-center text-center">
    <div className="mb-4 bg-emerald-50 p-4 rounded-full">
      <Icon className="w-8 h-8 text-emerald-500" />
    </div>
    <div className="flex items-baseline justify-center gap-1 mb-2">
      <span className="text-4xl font-bold text-gray-800 font-serif">{number}</span>
      {suffix && <span className="text-2xl text-gray-600">{suffix}</span>}
    </div>
    <p className="text-gray-600 text-sm md:text-base">{label}</p>
  </div>
);

const StatsSection = () => {
  const stats = [
    {
      icon: BarChart2,
      number: 100,
      suffix: '%',
      label: 'Pass Percentage in 10th & 12th'
    },
    {
      icon: Users,
      number: 3242,
      label: 'Students Enrolled'
    },
    {
      icon: CalendarDays,
      number: 20,
      label: 'Years of Experience'
    },
    {
      icon: Award,
      number: 26,
      label: 'Honors & Awards'
    }
  ];

  return (
    <div className="w-full bg-white-50 py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <StatsCard
              key={index}
              icon={stat.icon}
              number={stat.number}
              suffix={stat.suffix}
              label={stat.label}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsSection;